import { X } from "lucide-react";
import { useEffect, useState } from "react";
import { getCoachAthletes } from "../../../../services/adminApiService/batchManagementApi/BatchManagementApiService";

const CoachAthletesModal = ({ coach, onClose }) => {
  const [athletes, setAthletes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!coach?.id) return;
    setLoading(true);
    getCoachAthletes(coach.id)
      .then((res) => setAthletes(res?.data?.data ?? []))
      .catch(() => setAthletes([]))
      .finally(() => setLoading(false));
  }, [coach?.id]);

  return (
    <div className="training-modal-overlay">
      <div className="training-modal participants-modal">
        <div className="modal-header" style={{ padding: "0px" }}>
          <h5>
            {coach?.coach_name} — Athletes ({athletes.length})
          </h5>
          <button className="icon-btn" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="table-wrapper">
          {loading ? (
            <p className="text-center py-3">Loading...</p>
          ) : (
            <table className="table participants-table">
              <thead>
                <tr>
                  <th>Athlete Name</th>
                  <th>Phone</th>
                  <th>Sport</th>
                </tr>
              </thead>
              <tbody>
                {athletes.length > 0 ? (
                  athletes.map((a) => (
                    <tr key={a.id}>
                      <td>{a.name}</td>
                      <td>{a.mobile || "—"}</td>
                      <td>{a.sport_name || "—"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No athletes found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default CoachAthletesModal;
